import React from "react";
import { useApp } from "../../../../context/app";
import { formatDefaultValueSelect } from "../../../../utils/mask";
import styles from "./styles.module.scss";
import { FilterSelectAdmin } from "../../../../components/FilterSelectAdmin";
import { sortByDirection } from "../../../../utils/utils";
import { Button } from "@mui/material";

export function FiltrosReports({
  filtersSelectedValues,
  filterOptions,
  cidades,
  canaisDigitais,
  acoes,
  solucoes,
  regionais,
  isALL = true,
  isCPF,
  isCNPJ,
  cnaesFiltered,
  isErroSAS,
  isntErroSAS,
  allSAS,
  onDataInicioChange = null,
  onDataFimChange = null,
  onMesChange = null,
  onAnoChange = null,
  onUFChange = null,
  onCidadeChange = null,
  onTipoUserChange = null,
  onUserQueChange = null,
  onTempoAcessoChange = null,
  onPorteChange = null,
  onSegmentosChange = null,
  onCNAEChange = null,
  onPrimeiroAcessoChange = null,
  onUltimoAcessoChange = null,
  onQtdAcessoChange = null,
  onAtendenteChange = null,
  onHrEnvioChange = null,
  onRecorrenciaChange = null,
  onCanalChange = null,
  onInteracaoChange = null,
  onDiagnosticoChange = null,
  onTipoAtendimentoChange = null,
  onInstrumentoChange = null,
  onErroSASChange = null,
  onTemaChange = null,
  onChangeItem = () => {},
  typeFilters = null,
  updateFilters = undefined,
  isQtdAgente,
}) {
  const { filtersDashboard } = useApp();

  function handleDataInicioChage({ currentTarget }) {
    if (onDataInicioChange) {
      const newValue = currentTarget.value;
      onDataInicioChange(newValue);
    }
  }
  function handleDataFimChage({ currentTarget }) {
    if (onDataFimChange) {
      const newValue = currentTarget.value;
      onDataFimChange(newValue);
    }
  }
  function handleMesChange({ currentTarget }) {
    if (onMesChange) {
      const newValue = currentTarget.value;
      onMesChange(newValue);
    }
  }
  function handleAnoChange({ currentTarget }) {
    if (onAnoChange) {
      const newValue = currentTarget.value;
      onAnoChange(newValue);
    }
  }
  function handleUFChange({ currentTarget }) {
    if (onUFChange) {
      const newValue = currentTarget.value;
      onUFChange(newValue);
    }
  }
  function handleCidadeChange({ currentTarget }) {
    if (onCidadeChange) {
      const newValue = currentTarget.value;
      onCidadeChange(newValue);
    }
  }

  function handleTemaChange({ currentTarget }) {
    if (onTemaChange) {
      const newValue = currentTarget.value;
      const findedTema = filterOptions?.temas?.find(
        (t) => t.id.toString() === newValue
      );
      onTemaChange(findedTema);
    }
  }

  // function handleTipoUserChange({ currentTarget }) {
  //   if (onTipoUserChange) {
  //     const newValue = currentTarget.value;
  //     onTipoUserChange(newValue);
  //   }
  // }

  function handleUserQueChange({ currentTarget }) {
    if (onUserQueChange) {
      const newValue = currentTarget.value;
      onUserQueChange(newValue);
    }
  }

  function handleTempoAcessoChange({ currentTarget }) {
    if (onTempoAcessoChange) {
      const newValue =
        currentTarget.value === "Todos" ? "" : currentTarget.value;
      onTempoAcessoChange(newValue);
    }
  }

  function handlePorteChange({ currentTarget }) {
    if (onPorteChange) {
      const newValue = currentTarget.value;
      onPorteChange(newValue);
    }
  }
  function handleSegmentosChange({ currentTarget }) {
    if (onSegmentosChange) {
      const newValue = currentTarget.value;
      onSegmentosChange(newValue);
    }
  }
  function handleCNAEChange({ currentTarget }) {
    if (onCNAEChange) {
      const newValue = currentTarget.value;
      onCNAEChange(newValue);
    }
  }

  function handlePrimeiroAcessoChange({ currentTarget }) {
    if (onPrimeiroAcessoChange) {
      const newValue = currentTarget.value;
      onPrimeiroAcessoChange(newValue);
    }
  }
  function handleUltimoAcessoChange({ currentTarget }) {
    if (onUltimoAcessoChange) {
      const newValue = currentTarget.value;
      onUltimoAcessoChange(newValue);
    }
  }
  function handleQtdAcessoChange({ currentTarget }) {
    if (onQtdAcessoChange) {
      const newValue =
        currentTarget.value === "Todos" ? "" : currentTarget.value;
      onQtdAcessoChange(newValue);
    }
  }

  function handleAtendenteChange({ currentTarget }) {
    if (onAtendenteChange) {
      const newValue = currentTarget.value;
      onAtendenteChange(newValue);
    }
  }

  function handleHrEnvioChange({ currentTarget }) {
    if (onHrEnvioChange) {
      const newValue =
        currentTarget.value === "Todas" ? "" : currentTarget.value;
      onHrEnvioChange(newValue);
    }
  }
  function handleRecorrenciaChange({ currentTarget }) {
    if (onRecorrenciaChange) {
      const newValue =
        currentTarget.value === "Todas" ? "" : currentTarget.value;
      onRecorrenciaChange(newValue);
    }
  }

  function handleDiagnosticoChange({ currentTarget }) {
    if (onDiagnosticoChange) {
      const newValue =
        currentTarget.value === "Todos" ? "" : currentTarget.value;
      onDiagnosticoChange(newValue);
    }
  }
  function handleCanalDiagnosticoChange({ currentTarget }) {
    if (onCanalChange) {
      const newValue =
        currentTarget.value === "Todos" ? "" : currentTarget.value;
      onCanalChange(newValue);
    }
  }

  function handleTipoAtendimentoChange({ currentTarget }) {
    if (onTipoAtendimentoChange) {
      const newValue = currentTarget.value;
      onTipoAtendimentoChange(newValue);
    }
  }
  function handleInstrumentoChange({ currentTarget }) {
    if (onInstrumentoChange) {
      const newValue =
        currentTarget.value === "Todos" ? "" : currentTarget.value;
      onInstrumentoChange(newValue);
    }
  }

  function handleErroSASChange({ currentTarget }) {
    if (onErroSASChange) {
      const newValue = currentTarget.value;
      onErroSASChange(newValue);
    }
  }

  function handleCanalChange({ currentTarget }) {
    if (onCanalChange) {
      const newValue = currentTarget.value;
      onCanalChange(newValue);
    }
  }
  function handleInteracaoChange({ currentTarget }) {
    if (onInteracaoChange) {
      const newValue =
        currentTarget.value === "Todas" ? "" : currentTarget.value;
      onInteracaoChange(newValue);
    }
  }

  return (
    <div className={styles.big_container}>
      <div className={styles.content_left}>
        {/* LINHA 1 */}
        <div className={styles.data_row}>
          <div className={styles.data_IniFim}>
            {/* dt inicio */}
            <div>
              <div>
                <label htmlFor="dataInicio">Data Inicio</label>
              </div>
              <input
                disabled={
                  filtersSelectedValues?.mes || filtersSelectedValues?.ano
                }
                value={
                  filtersDashboard.dataInicial ??
                  filtersSelectedValues?.dataInicial ??
                  ""
                }
                id="dataInicio"
                name="dataInicio"
                type="date"
                max={"9999-12-31"}
                // className="date-picker"
                onChange={handleDataInicioChage}
              />
            </div>

            {/* dt fim */}
            <div>
              <div>
                <label htmlFor="dataFinal">Data Fim</label>
              </div>
              <input
                disabled={
                  filtersSelectedValues?.mes || filtersSelectedValues?.ano
                }
                value={
                  filtersDashboard.dataFinal ??
                  filtersSelectedValues?.dataFinal ??
                  ""
                }
                id="dataFinal"
                name="dataFinal"
                type="date"
                max={"9999-12-31"}
                // className="date-picker"
                onChange={handleDataFimChage}
              />
            </div>
          </div>

          <div className={styles.MesAno}>
            {/* mes */}
            <div>
              <div>
                <label htmlFor="input-mes">Mês</label>
              </div>
              <select
                id="input-mes"
                disabled={
                  filtersSelectedValues?.dataInicial ||
                  filtersSelectedValues?.dataFinal
                }
                value={filtersSelectedValues?.mes ?? ""}
                className="correct-color"
                onChange={handleMesChange}
              >
                <option value={""}>Selecione</option>
                {filterOptions?.meses &&
                  filterOptions?.meses.map((mes) => (
                    <option key={mes} value={mes}>
                      {formatDefaultValueSelect(mes)}
                    </option>
                  ))}
              </select>
            </div>

            {/* ano */}
            <div>
              <div>
                <label htmlFor="input-ano">Ano</label>
              </div>
              <select
                disabled={
                  filtersSelectedValues?.dataInicial ||
                  filtersSelectedValues?.dataFinal
                }
                className="correct-color"
                value={filtersSelectedValues?.ano ?? ""}
                onChange={handleAnoChange}
              >
                <option value={""}>Selecione</option>
                {filterOptions?.anos &&
                  filterOptions?.anos.sort().map((ano) => (
                    <option key={ano} value={ano}>
                      {ano}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>

        {/* LINHA 2 */}
        <div className={styles.ufCidade_row}>
          <div className={styles.uf_row_flex}>
            {/* UF */}
            <div className={styles.uf_row}>
              <div>
                <label htmlFor="input-uf">UF</label>
              </div>
              <select
                value={
                  filtersDashboard?.ufValueSelect?.id ??
                  filtersSelectedValues?.ufs ??
                  ""
                }
                className="correct-color"
                onChange={handleUFChange}
              >
                <option value={null}>Todas</option>
                {filterOptions?.ufs &&
                  filterOptions?.ufs
                    .sort((a, b) => {
                      return a?.sigla < b?.sigla
                        ? -1
                        : a?.sigla > b?.sigla
                        ? 1
                        : 0;
                    })
                    .map((uf) => (
                      <option key={uf.id} value={uf.id} title={uf.sigla}>
                        {uf.sigla}
                      </option>
                    ))}
              </select>
            </div>

            {/* CIDADE */}
            <div className={styles.cidade_row}>
              <div>
                <label htmlFor="input-cidade">Cidade</label>
              </div>
              <select
                value={
                  filtersDashboard?.cidadesValueSelect?.id ??
                  filtersSelectedValues?.cidades ??
                  ""
                }
                className="correct-color"
                onChange={handleCidadeChange}
              >
                <option value={""}>Todas</option>
                {cidades &&
                  cidades
                    ?.sort(function (a, b) {
                      return a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0;
                    })
                    .map((cidade) => (
                      <option
                        key={cidade.id}
                        value={cidade.id}
                        title={cidade.nome}
                      >
                        {cidade.nome}
                      </option>
                    ))}
              </select>
            </div>

            {/* Temas */}
            {!isQtdAgente && (
              <div
                className={styles.cidade_row}
                style={{ margin: "auto 10px" }}
              >
                <div>
                  <label htmlFor="input-cidade">Temas</label>
                </div>
                <select
                  value={
                    filtersDashboard?.tema?.id ??
                    filtersSelectedValues?.tema?.id ??
                    ""
                  }
                  className="correct-color"
                  onChange={handleTemaChange}
                >
                  <option value={null}>Todas</option>
                  {filterOptions?.temas &&
                    filterOptions?.temas
                      ?.sort(function (a, b) {
                        return a.descricao > b.descricao
                          ? 1
                          : b.descricao > a.descricao
                          ? -1
                          : 0;
                      })
                      .map((tema) => (
                        <option
                          key={tema.id}
                          value={tema.id}
                          title={tema.descricao}
                        >
                          {tema.descricao}
                        </option>
                      ))}
                </select>
              </div>
            )}
          </div>

          {/* TIPO USER */}
          {/*<div>*/}
          {/*  <div>*/}
          {/*    <label>Tipo de usuário</label>*/}
          {/*  </div>*/}
          {/*  <div className={styles.tipoUser_row}>*/}
          {/*    <div style={{ display: 'flex', flexDirection: 'row' }}>*/}
          {/*      <input*/}
          {/*        type="radio"*/}
          {/*        id="isALL"*/}
          {/*        name="tipo-user"*/}
          {/*        value="isAll"*/}
          {/*        checked={isALL}*/}
          {/*        onChange={handleTipoUserChange}*/}
          {/*      />*/}
          {/*      <label className={styles.tipoUser_label} htmlFor="isALL">*/}
          {/*        Todos*/}
          {/*      </label>*/}
          {/*    </div>*/}
          {/*    <div*/}
          {/*      style={{*/}
          {/*        display: 'flex',*/}
          {/*        flexDirection: 'row',*/}
          {/*        marginLeft: 10,*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      <input*/}
          {/*        type="radio"*/}
          {/*        id="isCPF"*/}
          {/*        name="tipo-user"*/}
          {/*        value="cpf"*/}
          {/*        checked={isCPF}*/}
          {/*        onChange={handleTipoUserChange}*/}
          {/*      />*/}
          {/*      <label className={styles.tipoUser_label} htmlFor="isCPF">*/}
          {/*        CPF*/}
          {/*      </label>*/}
          {/*    </div>*/}
          {/*    <div*/}
          {/*      style={{*/}
          {/*        display: 'flex',*/}
          {/*        flexDirection: 'row',*/}
          {/*        marginLeft: 10,*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      <input*/}
          {/*        type="radio"*/}
          {/*        id="isCNPJ"*/}
          {/*        name="tipo-user"*/}
          {/*        value="cnpj"*/}
          {/*        checked={isCNPJ}*/}
          {/*        onChange={handleTipoUserChange}*/}
          {/*      />*/}
          {/*      <label className={styles.tipoUser_label} htmlFor="isCNPJ">*/}
          {/*        CNPJ*/}
          {/*      </label>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>

        {/* LINHA 3 */}
        <div>
          <div>
            <label htmlFor="input-userQue">Usuários que</label>
          </div>
          <select
            value={filtersSelectedValues?.usuariosQue ?? ""}
            className="correct-color"
            onChange={handleUserQueChange}
          >
            <option value={""}>Todos</option>
            {filterOptions?.usuariosQue?.sort()?.map((uq) => (
              <option key={uq} value={uq} title={uq}>
                {formatDefaultValueSelect(uq)}
              </option>
            ))}
          </select>
        </div>

        {/* LINHA 4 */}
        {typeFilters === "atendimentosSse" && (
          <div className={styles.fourthRow}>
            <FilterSelectAdmin
              name={"canalDigital"}
              label={"Presença digital"}
              placeholder={"Todas"}
              value={filtersSelectedValues?.canalDigital}
              options={canaisDigitais}
              onChangeItem={onChangeItem}
              styleSelectContainer={{ padding: "0 0", backgroundColor: null }}
            />
            <FilterSelectAdmin
              name={"acao"}
              optionLabel={"nomeAcao"}
              returnAsObject={true}
              formatLabel={(value) =>
                value?.descricao || value?.id + " - " + value?.nomeAcao
              }
              label={"Ação"}
              placeholder={"Todas"}
              value={filtersSelectedValues?.acao}
              options={acoes}
              onChangeItem={onChangeItem}
              styleSelectContainer={{ padding: "0 0", backgroundColor: null }}
            />
          </div>
        )}
      </div>
      <div className={styles.content_right}>
        {/* LINHA 1 */}
        {typeFilters === "acessos" ? (
          <div className={styles.canalInteration}>
            {/* Tempo de acesso */}
            <div>
              <div>
                <label htmlFor="input-canal">Tempo de acesso</label>
              </div>
              <select
                value={filtersSelectedValues?.tempoAcesso ?? ""}
                className="correct-color"
                onChange={handleTempoAcessoChange}
              >
                <option value={null}>Todos</option>
                {filterOptions?.temposDeAcesso &&
                  filterOptions?.temposDeAcesso.map((tma) => (
                    <option key={tma} value={tma}>
                      {formatDefaultValueSelect(tma).replaceAll("_", " ")}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        ) : typeFilters === "agendamentos" ? (
          <div className={styles.canalInteration}>
            <div>
              <div>
                <label htmlFor="input-canal">Atendente</label>
              </div>
              <select
                value={filtersSelectedValues?.atendente ?? ""}
                className="correct-color"
                onChange={handleAtendenteChange}
              >
                <option value={""}>Todos</option>
                {filterOptions.atendentes &&
                  filterOptions?.atendentes.map((atendente) => (
                    <option key={atendente.id} value={atendente.id}>
                      {formatDefaultValueSelect(atendente.nome)}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        ) : typeFilters === "atendimentosSse" ? (
          <div className={styles.canalInteration}>
            {/* CANAL */}
            <div>
              <div>
                <label htmlFor="input-canal">Agente</label>
              </div>
              <select
                value={filtersSelectedValues?.atendentes?.id ?? ""}
                className="correct-color"
                onChange={handleCanalChange}
              >
                <option value={null}>Todos</option>
                {filterOptions.atendentes &&
                  filterOptions?.atendentes.map((at, idx) => (
                    <option key={idx} value={at.id}>
                      {formatDefaultValueSelect(at.nome)}
                    </option>
                  ))}
              </select>
            </div>

            {/* INTERAÇÃO */}
            <div>
              <div>
                <label htmlFor="input-interacao">Interação</label>
              </div>
              <select
                value={filtersSelectedValues?.interacao ?? ""}
                className="correct-color"
                onChange={handleInteracaoChange}
              >
                <option value={null}>Todas</option>
                {filterOptions.tiposInteracao &&
                  filterOptions?.tiposInteracao.map((val, idx) => (
                    <option key={idx} value={val}>
                      {formatDefaultValueSelect(val)}
                    </option>
                  ))}
              </select>
            </div>

            <FilterSelectAdmin
              name={"empresaVinculada"}
              label={"Empresa habilitada"}
              placeholder={"Todas"}
              value={filtersSelectedValues?.empresaVinculada}
              options={filterOptions?.empresasVinculadas}
              onChangeItem={onChangeItem}
              styleSelectContainer={{ padding: "0 0", backgroundColor: null }}
            />

            <FilterSelectAdmin
              name={"visita"}
              label={"Visita"}
              placeholder={"Todas"}
              formatLabel={formatDefaultValueSelect}
              value={filtersSelectedValues?.visita}
              options={filterOptions?.visita}
              onChangeItem={onChangeItem}
              styleSelectContainer={{ padding: "0 0", backgroundColor: null }}
            />

            <FilterSelectAdmin
              name={"portes"}
              returnAsObject={true}
              optionLabel="sigla"
              label={"Porte"}
              placeholder={"Todas"}
              value={
                filtersSelectedValues?.portes?.length &&
                filtersSelectedValues?.portes[0]
              }
              options={sortByDirection(filterOptions?.portes, "sigla")?.filter(
                (p) => p.sigla !== "Todos"
              )}
              onChangeItem={(event) => onChangeItem(event, true)}
              styleSelectContainer={{ padding: "0 0", backgroundColor: null }}
            />

            <FilterSelectAdmin
              name={"solucao"}
              label={"Soluções Sebrae"}
              placeholder={"Todas"}
              value={filtersSelectedValues?.solucao}
              options={solucoes}
              onChangeItem={onChangeItem}
              styleSelectContainer={{ padding: "0 0", backgroundColor: null }}
            />

            <FilterSelectAdmin
              name={"regionalProjetoAcao"}
              label={"Regionais"}
              placeholder={"Todas"}
              value={filtersSelectedValues?.regionalProjetoAcao}
              options={regionais}
              onChangeItem={onChangeItem}
              styleSelectContainer={{ padding: "0 0", backgroundColor: null }}
            />
          </div>
        ) : typeFilters === "diagnosticos" ? (
          <div className={styles.canalInteration}>
            {/* Diagnostico */}
            <div>
              <div>
                <label htmlFor="input-canal">Diagnóstico</label>
              </div>
              <select
                value={filtersSelectedValues?.nomeDiagnostico ?? ""}
                className="correct-color"
                onChange={handleDiagnosticoChange}
              >
                <option value={null}>Todos</option>
                {filterOptions.nomesDiagnostico &&
                  filterOptions?.nomesDiagnostico.map((nd) => (
                    <option value={nd}>{nd}</option>
                  ))}
              </select>
            </div>

            {/* Canal */}
            <div>
              <div>
                <label htmlFor="input-interacao">Canal</label>
              </div>
              <select
                value={filtersSelectedValues?.canal ?? ""}
                className="correct-color"
                onChange={handleCanalDiagnosticoChange}
              >
                <option value={null}>Todos</option>
                {filterOptions.canais &&
                  filterOptions.canais.map((cnl) => (
                    <option key={cnl} value={cnl}>
                      {cnl}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        ) : typeFilters === "notificacoes" ? (
          <div className={styles.canalInteration}>
            {/* Hora de Envio */}
            <div>
              <div>
                <label htmlFor="input-canal">Hora de Envio</label>
              </div>
              <select
                value={filtersSelectedValues?.horarioEnvio ?? ""}
                className="correct-color"
                onChange={handleHrEnvioChange}
              >
                <option value={null}>Todas</option>
                {filterOptions.horarioEnvio &&
                  filterOptions?.horarioEnvio.map((horario) => (
                    <option value={horario}>
                      {formatDefaultValueSelect(horario)}
                    </option>
                  ))}
              </select>
            </div>

            {/* Recorrencia */}
            <div>
              <div>
                <label htmlFor="input-interacao">Recorrência</label>
              </div>
              <select
                value={filtersSelectedValues?.recorrencia ?? ""}
                className="correct-color"
                onChange={handleRecorrenciaChange}
              >
                <option value={null}>Todas</option>
                {filterOptions.recorrencias &&
                  filterOptions?.recorrencias.map((recorrencia) => (
                    <option key={recorrencia} value={recorrencia}>
                      {formatDefaultValueSelect(recorrencia).replaceAll(
                        "_",
                        " "
                      )}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        ) : typeFilters === "registroSas" ? (
          <div className={styles.canalInteration}>
            {/* TIPO ATENDIMENTO */}
            <div>
              <div>
                <label htmlFor="input-canal">Tipo atendimento</label>
              </div>
              <select
                value={filtersSelectedValues?.tipoRealizacao ?? ""}
                className="correct-color"
                onChange={handleTipoAtendimentoChange}
              >
                <option value={null}>
                  {!filterOptions.tiposRealizacao ? "Carregando..." : "Todos"}
                </option>
                {filterOptions.tiposRealizacao &&
                  filterOptions?.tiposRealizacao.map((tr) => (
                    <option key={tr.id} value={tr.id}>
                      {tr.nome}
                    </option>
                  ))}
              </select>
            </div>

            {/* INSTRUMENTO */}
            <div>
              <div>
                <label htmlFor="input-interacao">Instrumento</label>
              </div>
              <select
                className="correct-color"
                value={filtersSelectedValues?.instrumento ?? ""}
                onChange={handleInstrumentoChange}
              >
                <option value={null}>
                  {!filterOptions.instrumentos ? "Carregando..." : "Todos"}
                </option>
                {filterOptions.instrumentos &&
                  filterOptions?.instrumentos.map((ins) => (
                    <option key={ins} value={ins}>
                      {formatDefaultValueSelect(ins)}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        ) : (
          <div className={styles.usuarios_acessos}>
            {/* Primeiro acesso */}
            <div>
              <div>
                <label htmlFor="input-primeiroAcesso">Primeiro acesso</label>
              </div>
              <input
                value={filtersSelectedValues?.primeiroAcesso ?? ""}
                id="primeiroAcesso"
                name="primeiroAcesso"
                max={"9999-12-31"}
                type="date"
                // className="date-picker"
                onChange={handlePrimeiroAcessoChange}
              />
            </div>

            {/* Ultimo acesso */}
            <div>
              <div>
                <label htmlFor="input-ultimoAcesso">Último acesso</label>
              </div>
              <input
                value={filtersSelectedValues?.ultimoAcesso ?? ""}
                id="ultimoAcesso"
                name="ultimoAcesso"
                max={"9999-12-31"}
                type="date"
                // className="date-picker"
                onChange={handleUltimoAcessoChange}
              />
            </div>

            {/* QTD de acessos */}
            <div>
              <div>
                <label htmlFor="input-qtdAcesso">Quantidade de acessos</label>
              </div>
              <select
                value={filtersSelectedValues?.quantidadeAcessos ?? ""}
                className="correct-color"
                onChange={handleQtdAcessoChange}
              >
                <option value={null}>Todos</option>
                {filterOptions?.quantidadeAcessos &&
                  filterOptions?.quantidadeAcessos.map((tma) => (
                    <option key={tma} value={tma}>
                      {formatDefaultValueSelect(tma)}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        )}
        {/* LINHA 2 */}
        <div>
          {isCNPJ && (
            <div className={styles.cnpj_arguments}>
              {/* PORTE */}
              <div>
                <div>
                  <label htmlFor="input-porte">Porte</label>
                </div>
                <select
                  id="input-porte"
                  value={filtersSelectedValues?.portes ?? ""}
                  className="correct-color"
                  onChange={handlePorteChange}
                >
                  <option value={null}>Todos</option>
                  {filterOptions?.portes &&
                    filterOptions?.portes.map((porte) => (
                      <option
                        key={porte.id}
                        value={porte.id}
                        title={porte.nomePorte}
                      >
                        {porte.nomePorte}
                      </option>
                    ))}
                </select>
              </div>

              {/* SEGMENTOS */}
              <div>
                <div>
                  <label htmlFor="input-segmentos">Segmentos</label>
                </div>
                <select
                  id="input-segmentos"
                  value={filtersSelectedValues?.segmentos ?? ""}
                  className="correct-color"
                  onChange={handleSegmentosChange}
                >
                  <option value={null}>Todos</option>
                  {filterOptions?.segmentos &&
                    filterOptions?.segmentos.map((seg) => (
                      <option key={seg.id} value={seg.id} title={seg.nome}>
                        {seg.nome}
                      </option>
                    ))}
                </select>
              </div>

              {/* CNAE */}
              <div>
                <div>
                  <label htmlFor="input-cnae">CNAE</label>
                </div>
                <select
                  id="input-cnae"
                  value={filtersSelectedValues?.cnaes ?? ""}
                  className="correct-color"
                  onChange={handleCNAEChange}
                >
                  <option value={null}>Todos</option>
                  {cnaesFiltered &&
                    cnaesFiltered
                      .sort((a, b) => a.descricao.localeCompare(b.descricao))
                      .map((cnae) => (
                        <option
                          key={cnae.id}
                          value={cnae.id}
                          title={cnae.descricao}
                        >
                          {cnae.descricao}
                        </option>
                      ))}
                </select>
              </div>
            </div>
          )}
        </div>
        {typeFilters === "registroSas" && (
          <div className={styles.erroSAS}>
            <label style={{ fontWeight: "bold" }}>Status Envio SAS</label>
            <div className={styles.inputRadioSAS}>
              <input
                type="radio"
                id="allSas"
                name="erro-sas"
                value="allSas"
                checked={allSAS}
                onChange={handleErroSASChange}
              />
              <label className={styles.tipoUser_label} htmlFor="allSas">
                Todos
              </label>
            </div>
            <div className={styles.inputRadioSAS}>
              <input
                type="radio"
                id="isErroSAS"
                name="erro-sas"
                value="erroSAS"
                checked={!!allSAS ? false : isErroSAS}
                onChange={handleErroSASChange}
              />
              <label className={styles.tipoUser_label} htmlFor="isErroSAS">
                Sim
              </label>
            </div>
            <div className={styles.inputRadioSAS}>
              <input
                type="radio"
                id="isntErroSAS"
                name="erro-sas"
                value="noErroSAS"
                checked={!!allSAS ? false : isntErroSAS}
                onChange={handleErroSASChange}
              />
              <label className={styles.tipoUser_label} htmlFor="isntErroSAS">
                Não
              </label>
            </div>
          </div>
        )}
      </div>
      <div></div>
      {updateFilters && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={updateFilters} variant="contained">
            Filtrar
          </Button>
        </div>
      )}
    </div>
  );
}
